import { render, staticRenderFns } from "./w-offices.vue?vue&type=template&id=d6cb265c"
import script from "./w-offices.vue?vue&type=script&lang=js"
export * from "./w-offices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports